import { getApiById, putApi } from "../../Shared/Services/RestService";
import { CompanyRequest, CompanyResponse } from "../Types/CompanyType";

export const getCompanyById = (id: string) => {
  return getApiById<CompanyResponse>("/companies", id);
};

export const updateCompany = (id: string, payload: CompanyRequest) => {
  return putApi<CompanyResponse>("/companies", id, payload);
};
